const CommonData = {
    state: {
        maskBox: false,
        padWarnShow: false,
        name: "",
        userType: "",
        icodeName: "ICode2020",
        userAvator: {},
    },

    mutations: {
        SET_ICOCE_NAME: (state, name) => {
            state.icodeName = name;
        },
        toggleMaskState: (state, value) => {
            state.maskBox = value;
        },
        setUserType: (state, value) => {
            state.userType = value;
        },
        setUserName: (state, value) => {
            state.name = value;
        },
        saveUserAvator: (state, value) => {
            state.userAvator = value
        }
    },

    actions: {
        updateICodeName({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                if (state.maskBox == true) {
                    reject(error);
                    return;
                }
                commit("SET_ICOCE_NAME", "ICode2021");
                resolve();
            });
        },
        // updateMaskBox({ commit, state }) {

        // }
    }
};
export default CommonData


// WEBPACK FOOTER //
// ./src/store/CommonData.js